import { useGetSignedUrl } from 'Data/s3.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let signedUrl = useGetSignedUrl({
    url: props?.value,
    download: true,
    viewPath: props.viewPath,
  })

  return signedUrl
}
